<template>
  <div 
  v-if="images" 
  class="interactive-image" 
  ref="container" 
  :data-grayscale="grayscale" 
  @mousemove="onMousemove" 
  @touchmove="onTouchmove" 
  @touchend="grayscale = true" 
  @touchstart="grayscale = false">
    <template v-if="loadImgs">
      <img v-for="image in images" :src="image.src" :data-visible="image.visible" :alt="alt">
    </template>
    <img v-else :src="mobileImgSrc" data-visible>
  </div>
</template>

<script>
import Config from 'src/config'
import _throttle from 'lodash/throttle'
import Prismic from 'prismic.io'
import getRespImgSrc from 'assets/js/getRespImgSrc'
export default {
  name: 'InteractiveImage',
  props: ['id', 'alt'],
  data () {
    return {
      images: null,
      defaultImgSet: false,
      mobileImgSrc: false,
      loadImgs: window.innerWidth > Config.bkpt.image360 && !this.$route.meta.hide360Images,
      bounding: null,
      resizeTimeout: null,
      grayscale: true
    }
  },
  watch: {
    '$route' (to, from) {
      if (window.innerWidth > Config.bkpt.image360 && !to.meta.firstPage) this.loadImgs = true
    }
  },
  methods: {
    setImgSrc (image) {
      return getRespImgSrc(image, 'image')
    },
    setImgVisiblity (image) {
      return image.fragments['default-image'] ? image.getBoolean('default-image') : false
    },
    getImages () {
      if (this.id) {
        Prismic.api(Config.prismic.api_url).then((api) => {
          return api.getByID(this.id) // An empty query will return all the documents
        }).then((response) => {
          this.buildImages(response.getGroup('interactive-image.images').value)
        }, function (err) {
          console.log('Error getting Interactive Image: ', err)
        })
      }
    },
    buildImages (images) {
      const imgs = []
      for (var i = 0; i < images.length; i++) {
        let img = {}
        img.src = getRespImgSrc(images[i], 'image')
        img.visible = images[i].fragments['default-image'] ? images[i].getBoolean('default-image') : false
        this.mobileImgSrc = img.visible ? img.src : this.mobileImgSrc
        imgs.push(img)
      }
      this.images = imgs
    },
    toggleImagesByXPos (offsetX) {
      if (this.loadImgs) {
        const boxWidth = this.$refs.container.offsetWidth
        const sliceQuotient = boxWidth / this.images.length
        // set index
        let index = Math.floor(offsetX / sliceQuotient) // index = what 'slice' is it in
        index = index < 0 ? 0 : index // min
        index = index > this.images.length - 1 ? this.images.length - 1 : index  // max
        // hide / show
        this.images.map(function (item) { item.visible = false })
        this.images[index].visible = true
      }
    },
    setBounding () {
      if (this.$refs.container) this.bounding = this.$refs.container.getBoundingClientRect()
      // console.log(this.bounding)
    },
    onMousemove: _throttle(function (e) {
      this.toggleImagesByXPos(e.offsetX)
    }, 0),
    onTouchmove: _throttle(function (e) {
      const x = e.changedTouches[0].pageX - this.bounding.left
      this.toggleImagesByXPos(x)
    }, 50),
    onResize () {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(() => {
        this.setBounding()
      }, 300)
    }
  },
  created () {
    this.getImages()
    window.addEventListener('resize', this.onResize)
  },
  updated () {
    if (this.bounding === null) this.setBounding()
  },
  destroyed () {
    clearTimeout(this.resizeTimeout)
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.interactive-image{
  position:relative;
  width:100%;
  padding-bottom:130%;
  overflow:hidden;
  background-color:whitesmoke;
  img{
    @include background(absolute,auto);
    width:100%;
    display:block;
    opacity:0;
    &[data-visible]{
      opacity:1;
    }
  }

  // grayscale
  .no-touchevents & {
    @include filter(grayscale(100%));
    @include transition(filter .5s, -webkit-filter .5s);  
    &:hover{
      @include filter(grayscale(0));
    }
  }
  .touchevents &{
    @include transition(filter .5s, -webkit-filter .5s);  
    &[data-grayscale] {
      @include filter(grayscale(100%));
    }
  }
}
</style>



// WEBPACK FOOTER //
// InteractiveImage.vue?0a04931e